import { makeTransform, scale, translateY } from '@remotion/animation-utils';
import { VideoTheme } from '../../types';
import { interpolate } from 'remotion';
import Box from '@mui/material/Box';
import { SxProps } from '@mui/system';

interface WordProps {
  word: string;
  color: string;
  fontSize: number;
  theme: VideoTheme;
  customWordStyle?: SxProps;
}

export const Word: React.FC<WordProps> = ({ word, color, fontSize, theme, customWordStyle }) => (
  <Box
    sx={{
      ...styles.word,
      fontSize,
      color,
      fontFamily: theme.fontStyle.fontFamily,
      fontWeight: theme.fontStyle.fontWeight,
      ...customWordStyle,
    }}
  >
    {word}
  </Box>
);

const styles: { [key: string]: React.CSSProperties } = {
  word: {
    flex: '0 1 auto',
    textTransform: 'uppercase',
    textAlign: 'center',
  },
};
